export default __webpack_public_path__ + "c47c26983f60ce5dc3407fab520af766.png";